import React, { useRef, useMemo, useState, useEffect } from "react";
import { Box, Typography, Button, Chip } from "@mui/material";
import CommonButton from "../../components/common/CommonButton/CommonButton";
import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate, useLocation } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import StepActions from "./StepActions";
import Modal from "@mui/material/Modal";
import GradeReportsGrid from "../GradeReports/GradeReportsGrid";
import PartnerReportsGrid from "../GradeReports/PartnerReportsGrid";
import GradeReportsHeaderActions from "../GradeReports/GradeReportsHeaderActions";
import {
  DataGridPro,
  useGridApiRef,
  GridRowSelectionModel,
} from "@mui/x-data-grid-pro";
import Checkbox from "@mui/material/Checkbox";
import ListItemIcon from "@mui/material/ListItemIcon";
import DeleteIcon from "@mui/icons-material/Delete";

import IconButton from "@mui/material/IconButton";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import { createReportItem } from "../../services/activityReportService";

const modalStyles = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "65%",
  height: "80%",
  bgcolor: "background.paper",
  border: "1px solid #E0E3E5",
  boxShadow: 24,
  p: 4,
  borderRadius: "18px",
  display: "flex",          // ADD
  flexDirection: "column",  // ADD
  overflow: "hidden",       // ADD
};

const flagButtonStyles = {
  padding: 2,
  paddingInline: 1,
  margin: 0,
  minWidth: "0px",
  position: "relative",
  left: "2px",
  borderRadius: "80%",
  height: "24px",
};

const Step2Companies = () => {
  const navigate = useNavigate();
  const location = useLocation();


  const [open, setOpen] = React.useState(false);
  const [screen, setScreen] = useState(1); // 1 or 2

  const [companies, setCompanies] = React.useState([]);
  const [selectedPartners, setSelectedPartners] = useState({});

  const [accumulatePartners, setAccumulatePartners] = useState([]);

  const [selectedCompanies, setSelectedCompanies] = useState([]);

  const [selectedRows, setSelectedRows] = useState([]);

  const [companyQty, setCompanyQty] = useState(0);

  const [idCompanies, setIdCompanies] = useState([]);

  const [modalKey, setModalKey] = useState(0);

  const [searchText, setSearchText] = React.useState("");

  const gridApiRef = useGridApiRef(); // ← ADD THIS — shared apiRef for the modal grid

  const mainGridApiRef = useGridApiRef(); // ← for the main page grid (not modal)

  const settingsData = location.state?.settingsData;

  const isEditMode = location.state?.isEditMode || false;
  const incomingCompanies = location.state?.companiesData || [];

  useEffect(() => {
    console.log("Step2 incomingCompanies:", incomingCompanies);
    console.log("Step2 isEditMode:", isEditMode);
    console.log("Step2 full location.state:", location.state);
  }, []);

  // Redirect if no data from previous steps
  useEffect(() => {
    if (!settingsData) {
      navigate('/create-request');
    }
  }, [settingsData, navigate]);

  // Pre-populate companies when in edit/settings mode
  useEffect(() => {
    if (incomingCompanies.length === 0) return;

    // Check if companies are already in the "selected" shape (coming back from Step 3)
    // Step 3 passes company[] with lowercase 'company' field
    const savedShapeItems = incomingCompanies.filter(
      (item) => item.company !== undefined
    );

    if (savedShapeItems.length === 0) return;

    const mapped = savedShapeItems.map((item, idx) => ({
      id: item.id || `saved-${item.company}-${idx}`,
      Company: item.company || "",
      Partner: item.partners?.[0]?.partner_name || "",
      partnerDoc: item.partners?.[0]?.partner_docname || "",
      Grade: item.grade || "",
      location: item.location || "",
      InvestmentCapital: item.invested_capital || 0,
      CashOutDate: item.cashout || "",
    }));

    setSelectedCompanies(mapped);
  }, []);



  // Initialize function to set all checkboxes to checked
  const initializeAllPartnersChecked = (data) => {
    const initialSelected = {};
    const initialAccumulated = [];

    data.forEach((row) => {
      const partnerItems = row.Items || [];
      partnerItems.forEach((item) => {
        if (item.id) {
          initialSelected[item.id] = true;
          initialAccumulated.push(item.id);
        }
      });
    });

    setSelectedPartners(initialSelected);
    setAccumulatePartners([...new Set(initialAccumulated)]); // Remove duplicates
  };

  const arrowButtonStyles = {
    padding: 0,
    margin: 0,
    minWidth: "0px",
    position: "relative",
    left: "2px",
  };

  // Add this helper function at the top of Step2Companies.jsx (after imports)
  const getCompanyLogo = (companyName) => {
    const logoMap = {
      ServiceTitan: "https://cdn.brandfetch.io/servicetitan.com/fallback/lettermark/theme/dark/h/512/w/512/icon?c=1bfwsmEH20zzEfSNTed",
      Canva: "https://cdn.brandfetch.io/canva.com/fallback/lettermark/theme/dark/h/512/w/512/icon?c=1bfwsmEH20zzEfSNTed",
      Adobe: "https://cdn.brandfetch.io/adobe.com/fallback/lettermark/theme/dark/h/512/w/512/icon?c=1bfwsmEH20zzEfSNTed",
      Asana: "https://cdn.brandfetch.io/asana.com/fallback/lettermark/theme/dark/h/512/w/512/icon?c=1bfwsmEH20zzEfSNTed",
    };
    return (
      logoMap[companyName] ||
      `https://ui-avatars.com/api/?name=${encodeURIComponent(companyName)}&background=random&size=512`
    );
  };

  const handleOpen = () => {
    console.log("Opening modal, current selected companies: ", selectedCompanies);
    // Increment key to force reset of the grid when reopening
    setModalKey(prev => prev + 1);
    // Reset screen to first view
    setScreen(1);
    // Reset temporary selections in modal
    setCompanies([]);
    setSearchText("");
    setOpen(true);
  };
  const handleClose = () => {
    console.log("Closing modal");
    setOpen(false);
    setScreen(1);
    // Reset companies (the temporary selection in modal)
    setCompanies([]);
    // Reset search text
    setSearchText("");
  };


  const nextScreen = () => {
    // Re-initialize checkbox state from scratch based on current companies
    // This ensures unchecked parent rows (which remove companies from the list)
    // are properly reflected — avoids stale accumulatePartners from previous selection
    const freshSelected = {};
    const freshAccumulated = [];

    companies.forEach((item) => {
      if (item.id) {
        freshSelected[item.id] = true;
        freshAccumulated.push(item.id);
      }
    });

    setSelectedPartners(freshSelected);
    setAccumulatePartners([...new Set(freshAccumulated)]);
    setScreen(2);
  };

  const prevScreen = () => {
    setScreen(1);
  };

  const tableRef = useRef(null);

  const handleOpenColumns = () => {
    console.log("handleOpenColumns called");
    console.log("tableRef.current:", tableRef.current);
    console.log("tableRef.current.openColumnsPanel:", tableRef.current?.openColumnsPanel);
    console.log("gridApiRef.current:", gridApiRef.current);
    console.log("gridApiRef.current.showPreferences:", gridApiRef.current?.showPreferences);

    if (tableRef.current?.openColumnsPanel) {
      console.log("→ Using tableRef imperative handle");
      tableRef.current.openColumnsPanel();
    } else if (gridApiRef.current?.showPreferences) {
      console.log("→ Using gridApiRef directly");
      gridApiRef.current.showPreferences("columns");
    } else {
      console.error("→ Neither tableRef nor gridApiRef is available!");
    }
  };

  const handleOpenFilters = () => {
    console.log("handleOpenFilters called");
    console.log("tableRef.current:", tableRef.current);
    console.log("tableRef.current.openFiltersPanel:", tableRef.current?.openFiltersPanel);
    console.log("gridApiRef.current:", gridApiRef.current);

    if (tableRef.current?.openFiltersPanel) {
      console.log("→ Using tableRef imperative handle");
      tableRef.current.openFiltersPanel();
    } else if (gridApiRef.current?.showPreferences) {
      console.log("→ Using gridApiRef directly");
      gridApiRef.current.showPreferences("filters");
    } else {
      console.error("→ Neither tableRef nor gridApiRef is available!");
    }
  };

  const handleMainOpenColumns = () => {
    console.log("handleMainOpenColumns called");
    console.log("mainGridApiRef.current:", mainGridApiRef.current);
    if (mainGridApiRef.current?.showPreferences) {
      mainGridApiRef.current.showPreferences("columns");
    } else {
      console.error("mainGridApiRef not ready");
    }
  };

  const handleMainOpenFilters = () => {
    console.log("handleMainOpenFilters called");
    console.log("mainGridApiRef.current:", mainGridApiRef.current);
    if (mainGridApiRef.current?.showPreferences) {
      mainGridApiRef.current.showPreferences("filters");
    } else {
      console.error("mainGridApiRef not ready");
    }
  };

  // child always sends the full current selection:
  const handleCompaniesFromChild = (newCompanies) => {
    console.log("Companies selected in parent: ", newCompanies);
    setCompanies(newCompanies); // Full replace — no merge needed
  };

  const aggregateRows = () => {
    console.log("Adding selected companies...", companies);

    console.log("accumulatePartners: ", accumulatePartners);

    const filteredCompanies = companies.filter((company) =>
      accumulatePartners.includes(company.id),
    );

    console.log("Filtered Companies to add: ", filteredCompanies);

    // Merge with existing selectedCompanies
    setSelectedCompanies(prevSelected => {
      const selectedMap = new Map();

      // Add existing selected companies
      prevSelected.forEach(company => {
        if (company && company.id) {
          selectedMap.set(company.id, company);
        }
      });

      // Add newly selected companies
      filteredCompanies.forEach(company => {
        if (company && company.id) {
          selectedMap.set(company.id, company);
        }
      });

      const mergedSelected = Array.from(selectedMap.values());

      console.log('Selected companies merged:', {
        previousCount: prevSelected.length,
        newCount: filteredCompanies.length,
        totalCount: mergedSelected.length
      });

      return mergedSelected;
    });

    handleClose();

    renderCompaniesSection();
  };

  // Handle bulk delete of partner records from selected companies
  const handleBulkDelete = () => {
    console.log("Bulk deleting companies with IDs: ", idCompanies);

    // Remove companies that are marked for deletion
    setSelectedCompanies(prevSelected => {
      const updatedSelected = prevSelected.filter(company => !idCompanies.includes(company.id));

      console.log('Bulk delete completed:', {
        previousCount: prevSelected.length,
        deletedCount: idCompanies.length,
        remainingCount: updatedSelected.length
      });

      return updatedSelected;
    });

    // Clear selected rows and IDs after deletion
    setSelectedRows([]);
    setIdCompanies([]);
    setCompanyQty(0);

    // Trigger modal refresh by incrementing modalKey when modal is open
    if (open) {
      setModalKey(prev => prev + 1);
    }
  };

  // Handle final company selection from the main grid
  const handleCompanySelectionChange = (newSelection) => {
    console.log("Selected company IDs raw: ", newSelection);
    let idC2 = [];

    if (Array.isArray(newSelection)) {
      // Old format — plain array of ids
      idC2 = newSelection;
    } else if (newSelection instanceof Set) {
      // Set format
      idC2 = [...newSelection];
    } else if (newSelection?.type === 'include' && newSelection?.ids instanceof Set) {
      // DataGridPro v7+ format for partial selection
      idC2 = [...newSelection.ids];
    } else if (newSelection?.type === 'exclude') {
      // "Select all" uses exclude format — get all row ids minus excluded
      const allIds = filteredReports.map(row => row.id);
      const excludedIds = newSelection.ids instanceof Set
        ? [...newSelection.ids]
        : [];
      idC2 = allIds.filter(id => !excludedIds.includes(id));
    } else if (newSelection?.ids) {
      idC2 = [...newSelection.ids];
    }

    console.log("Resolved idC2: ", idC2, " count: ", idC2.length);
    setIdCompanies(idC2);
    setCompanyQty(idC2.length);
  };

  // Handle checkbox change
  const handleCheckboxChange = (partner, partnerItems, index) => (event) => {
    const isChecked = event.target.checked;
    const partnerId = partnerItems[index].id;

    if (!partnerId) return;

    // Update selectedPartners state
    setSelectedPartners((prev) => ({
      ...prev,
      [partnerId]: isChecked,
    }));

    // Update accumulated partners
    setAccumulatePartners((prev) => {
      if (isChecked) {
        // Add partnerId if checked and not already in array
        if (!prev.includes(partnerId)) {
          return [...prev, partnerId];
        }
      } else {
        // Remove partnerId if unchecked
        return prev.filter((id) => id !== partnerId);
      }
      return prev;
    });
  };

  // For better tracking, use useEffect to log when state updates
  //   React.useEffect(() => {
  //     console.log("Current accumulatePartners: ", accumulatePartners);
  //   }, [accumulatePartners]);

  // Grouped view: Show partners grouped under companies
  const groupedData = useMemo(() => {
    const groups = {};

    // Create groups by company
    companies.forEach((item, index) => {
      if (
        item.Company &&
        item.Company !== 0 &&
        item.Company !== "3 Companies"
      ) {
        const company = item.Company;
        if (!groups[company]) {
          groups[company] = {
            company,
            partners: [],
            partnersId: [],
            items: [],
          };
        }
        groups[company].partners.push(item.Partner + "- " + item.id);
        groups[company].partnersId.push(item.id);
        groups[company].items.push(item);

        // console.log("groups[company]: ", groups[company]);
      }
    });

    // Remove duplicates and create rows
    return Object.entries(groups).map(([company, data], index) => ({
      id: `group-${index}`,
      Company: company,
      Partners: [...new Set(data.partners)],
      PartnerCount: new Set(data.partners).size,
      Items: data.items,
    }));
  }, [companies]);

  // REPLACE with this — only initialize for NEW items not already tracked:
  React.useEffect(() => {
    if (groupedData.length === 0) return;

    setSelectedPartners((prevSelected) => {
      const newSelected = { ...prevSelected };
      let hasNew = false;

      groupedData.forEach((row) => {
        const partnerItems = row.Items || [];
        partnerItems.forEach((item) => {
          if (item.id && !(item.id in newSelected)) {
            // Only set to true if this ID hasn't been seen before
            newSelected[item.id] = true;
            hasNew = true;
          }
        });
      });

      return hasNew ? newSelected : prevSelected;
    });

    setAccumulatePartners((prevAccumulated) => {
      const newAccumulated = [...prevAccumulated];
      let hasNew = false;

      groupedData.forEach((row) => {
        const partnerItems = row.Items || [];
        partnerItems.forEach((item) => {
          if (item.id && !prevAccumulated.includes(item.id)) {
            // Only add if not already tracked (preserves unchecked state)
            newAccumulated.push(item.id);
            hasNew = true;
          }
        });
      });

      return hasNew ? [...new Set(newAccumulated)] : prevAccumulated;
    });
  }, [groupedData]);

  const cleanSelectedPartners = (partner) => {
    return partner.split("-")[0].trim();
  };


  useEffect(() => {
    if (open && selectedCompanies.length >= 0) {
      // Increment modalKey to refresh the grid when selectedCompanies changes
      setModalKey(prev => prev + 1);
    }
  }, [selectedCompanies.length, open]);

  // Grouped columns for the second screen in modal window are partners under companies
  const groupedColumns = [
    {
      field: "Company",
      headerName: "Company",
      width: 280,
      minWidth: 240,
      renderCell: (params) => {
        const companyName = params.value;
        return (
          <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
            <img
              src={getCompanyLogo(companyName)}
              alt={companyName}
              style={{ width: 24, height: 24, borderRadius: "50%" }}
              onError={(e) => {
                e.target.src = `https://ui-avatars.com/api/?name=${encodeURIComponent(companyName)}&background=random&size=512`;
              }}
            />
            <Typography fontWeight="medium" variant="body1" sx={{ lineHeight: 3 }}>
              {companyName}
            </Typography>
          </Box>
        );
      },
    },
    {
      field: "Partners",
      headerName: "Partner(s)",
      width: 300,
      flex: 1,
      minWidth: 200,
      renderCell: (params) => {
        const partners = params.row.Partners || [];
        const partnerItems = params.row.Items;
        const count = params.row.PartnerCount || 0;

        // Get all partner IDs for this row
        const rowPartnerIds = partnerItems.map((item) => item.id);

        return (
          <Box sx={{ py: 1 }}>
            <FormGroup
              sx={{
                display: "flex",
                flexDirection: "row",
                flexWrap: "wrap",
                gap: 2,
              }}
            >
              {partners.map((partner, index) => {
                // Find the corresponding item for this partner
                const partnerItem = partnerItems[index];
                const partnerId = partnerItem?.id;

                // Check if this partner is selected
                const isSelected =
                  selectedPartners[partnerId] !== undefined
                    ? selectedPartners[partnerId]
                    : true; // Default to true (checked)

                return (
                  <Box key={index}>
                    <FormControlLabel
                      key={index}
                      control={
                        <Checkbox
                          size="small"
                          checked={isSelected}
                          onChange={handleCheckboxChange(
                            partner,
                            partnerItems,
                            index,
                          )}
                          sx={{
                            py: 0.5,
                            "& .MuiSvgIcon-root": { fontSize: 18 },
                          }}
                        />
                      }
                      label={
                        <Typography variant="body2">
                          {cleanSelectedPartners(partner)}
                        </Typography>
                      }
                      sx={{
                        m: 0,
                        "& .MuiFormControlLabel-label": { ml: 0.5 },
                      }}
                    />
                  </Box>
                );
              })}
            </FormGroup>
            {count > 1 && (
              <Typography variant="caption" color="text.secondary">
                {count} partners working with this company
              </Typography>
            )}
          </Box>
        );
      },
    },
  ];

  // Columns for the main companies grid
  const columns = [
    {
      field: "Partner",
      headerName: "Partner",
      flex: 1.2,
      hide: true,
    },
    {
      field: "Company",
      headerName: "Company",
      flex: 1,
      renderCell: (params) => {
        const isParent = params.row._isParent;
        const childCount = params.row._childCount || 0;
        const treeDepth = params.rowNode?.depth || 0;
        const companyName = params.value;


        return (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              pl: treeDepth * 4,
              width: "100%",
              marginTop: "15px",
            }}
          >
            {!isParent && (
              <img
                src={getCompanyLogo(companyName)}
                alt={companyName}
                style={{ width: 24, height: 24, borderRadius: "50%" }}
                onError={(e) => {
                  e.target.src = `https://ui-avatars.com/api/?name=${encodeURIComponent(companyName)}&background=random&size=512`;
                }}
              />
            )}

            {isParent && (
              <Chip
                label={`${childCount} Companies`}
                size="small"
                sx={{
                  ml: 1,
                  height: 20,
                  fontSize: "0.7rem",
                  backgroundColor: "white",
                  color: "primary",
                }}
              />
            )}

            {!isParent && (
              <Typography variant="body2">{params.value}</Typography>
            )}
          </Box>
        );
      },
    },
    {
      field: "location",
      headerName: "Location",
      flex: 1,
    },
    {
      field: "Grade",
      headerName: "Grade",
      flex: 1,
      renderCell: (params) => {
        return (
          <Box
            sx={{
              textAlign: "left",
            }}
          >
            {params.value}
          </Box>
        );
      },
    },
    {
      field: "InvestmentCapital",
      headerName: "Inv. Cap",
      headerAlign: "right",
      flex: 1,
      valueFormatter: (params) => {
        const value = params.value || 0;

        // Format to millions with one decimal place
        if (value >= 1000000) {
          return `$${(value / 1000000).toFixed(1)}M`;
        }
        if (value >= 1000) {
          return `$${(value / 1000).toFixed(0)}K`;
        }
        return `$${value}`;
      },
      renderCell: (params) => {
        const isParent = params.row._isParent;

        // Format for display (same as valueFormatter)
        const formatToMillions = (num) => {
          if (num >= 1000000) {
            return `$${(num / 1000000).toFixed(1)}M`;
          }
          if (num >= 1000) {
            return `$${(num / 1000).toFixed(0)}K`;
          }
          return `$${num}`;
        };

        return (
          <Box
            sx={{
              display: "flex",
              flexDirection: "row-reverse",
              width: "100%",
              marginTop: "15px",
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center" }}>
              {isParent && (
                <Chip
                  label={`${formatToMillions(params.value)}`}
                  size="small"
                  sx={{
                    ml: 1,
                    height: 20,
                    fontSize: "0.7rem",
                    backgroundColor: "white",
                    borderBottom: "1px solid #5A60664D",
                    color: "primary",
                  }}
                />
              )}

              {!isParent && (
                <Typography
                  variant="body2"
                  sx={{
                    fontWeight: 400,
                    color: "inherit",
                  }}
                >
                  {(formatToMillions(params.value) || 0).toLocaleString()}
                </Typography>
              )}
            </Box>
          </Box>
        );
      },
    },
    {
      field: "CashOutDate",
      headerName: "Cash Out",
      flex: 1,
    },
    {
      field: "actions",
      headerName: "",
      flex: 1,
      sortable: false,
      filterable: false,
      fixed: true,
      renderCell: (params) => {
        if (params.row._isParent) {
          return null; // Return nothing for parent nodes
        }

        // Use params to avoid unused variable warning
        return (
          <>
            {/* <CommonButton
              variant="contained"
              size="medium"
              color="secondary"
              sx={{ padding: "4px 10px" }}
            // onClick={ (e) => {e.stopPropagation(); navigate(`/grade-reports/${params.row.id}`); }}
            >
              Edit
            </CommonButton> */}

            <CommonButton
              variant="contained"
              size="medium"
              color="secondary"
              sx={{
                marginLeft: 1,
                padding: "5px",
                minWidth: "0px",
              }}
              onClick={() => {
                deletePartnerRecord(params.row.id);
              }}
            >
              <ListItemIcon sx={{ minWidth: "0px" }}>
                <DeleteIcon
                  fontSize="small"
                  sx={{
                    color: "#1A1919",
                  }}
                />
              </ListItemIcon>
            </CommonButton>
          </>
        );
      },
    },
  ];

  const filteredReports = useMemo(() => {
    if (!searchText) return selectedCompanies;

    const query = searchText.toLowerCase();
    return selectedCompanies.filter((row) =>
      Object.values(row).some((value) =>
        String(value).toLowerCase().includes(query),
      ),
    );
  }, [selectedCompanies, searchText]);

  // Delete partner record from selected companies
  const deletePartnerRecord = (partnerId) => {
    console.log("Deleting single company with ID: ", partnerId);

    setSelectedCompanies(prevSelected => {
      const updatedSelected = prevSelected.filter(company => company.id !== partnerId);

      console.log('Single delete completed:', {
        deletedId: partnerId,
        previousCount: prevSelected.length,
        remainingCount: updatedSelected.length
      });

      return updatedSelected;
    });

    // Trigger modal refresh by incrementing modalKey when modal is open
    if (open) {
      setModalKey(prev => prev + 1);
    }
  };

  const renderCompaniesSection = () => {
    if (selectedCompanies.length > 0) {
      return (
        <Box sx={{ position: "relative", bottom: "60px" }}>
          <GradeReportsHeaderActions
            searchText={searchText}
            onSearchChange={setSearchText}
            onOpenColumns={handleMainOpenColumns}
            onOpenFilters={handleMainOpenFilters}
            isStatusFilterActive={false}
            isAddCompaniesBtn={true}
            onHandleOpen={handleOpen}
            onCompanyQty={companyQty}
            onBulkDelete={handleBulkDelete}
          />

          <DataGridPro
            key={`main-grid-${selectedCompanies.length}`}
            apiRef={mainGridApiRef}
            rows={filteredReports}
            columns={columns}
            checkboxSelection={true}
            hideFooterSelectedRowCount={true}
            hideFooter={true}
            disableRowSelectionOnClick
            onRowSelectionModelChange={(newSelection) => {
              // Sync visual selection state
              setSelectedRows(newSelection);
              handleCompanySelectionChange(newSelection);
            }}
            // treeData
            // getTreeDataPath={(row) => row.path}
            // defaultGroupingExpansionDepth={-1}

            selectionModel={selectedRows}
          //onRowSelectionModelChange={handleCompanySelectionChange}
          // Important: Add a getRowId prop if your rows don't have an 'id' field
          // getRowId={(row) => row.uniqueIdField}
          />
        </Box>
      );
    } else {
      return (
        <Box
          sx={{
            flex: 1,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            mb: 4,
            flexDirection: "column",
          }}
        >
          <img src="/Building.png" />
          <Typography
            sx={{ color: "#1A1919", fontSize: "14px", fontWeight: 600 }}
          >
            No Companies added
          </Typography>
          <Typography
            sx={{ color: "#757677", fontSize: "14px", fontWeight: 400, mb: 2 }}
          >
            Add companies or partners to send this report.
          </Typography>
          <Button
            variant="contained"
            onClick={handleOpen}
            startIcon={<AddIcon />}
            sx={{
              textTransform: "none",
              bgcolor: "#0369A1",
              borderRadius: "20px", // Pill shape
              px: 3,
              py: 1,
              fontWeight: 600,
              fontSize: "14px",
              "&:hover": {
                bgcolor: "#025a87",
              },
            }}
          >
            Add Companies
          </Button>
        </Box>
      );
    }
  };

  const onSubmit = async () => {
    try {
      let convertedCompanies = filteredReports.map((row) => ({
        company: row?.Company || "",
        deal_id: row?.deal_id || null,  // ✅ ADD THIS
        grade: row?.Grade || "",
        location: row?.location || "",
        invested_capital: row?.InvestmentCapital || 0,
        cashout: row?.CashOutDate || "",
        partners: [
          {
            partner_name: row?.Partner || "",
            partner_docname: row?.partnerDoc || "",
          },
        ],
      }));
      const step2FormData = {
        report_name: settingsData.report_name,
        period_end_date: settingsData.period_end_date,
        period_start_date: settingsData.period_start_date,
        due_date: settingsData.due_date,
        request_type: settingsData.request_type,
        company: [...convertedCompanies],
        request_data: [],
        report_sent_on: new Date().toISOString(),
        status: 4,
        created_at: new Date().toISOString(),
      };

      await createReportItem(step2FormData);

      // Redirect after success
      setTimeout(() => {
        navigate('/activity-reports');
      }, 3000);

    } catch (error) {
      console.error("Error saving draft: ", error);
    }
  }

  return (
    <Box sx={{ mx: "auto", mt: 6 }}>
      {/* Main Content Card */}
      <Box
        sx={{
          borderRadius: "16px",
          minHeight: "300px",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {/* Center Section: Add Companies Button */}
        {renderCompaniesSection()}
      </Box>


      {/* Footer Actions (Preview, Save Draft, Next) */}

      <StepActions
        onNext={() => {
          console.log(
            "Navigation to report step: ",
            location.state.settingsData,
          );

          let convertedCompanies = filteredReports.map((row) => ({
            company: row?.Company || "",
            deal_id: row?.deal_id || null,  // ✅ ADD THIS
            grade: row?.Grade || "",
            location: row?.location || "",
            invested_capital: row?.InvestmentCapital || 0,
            cashout: row?.CashOutDate || "",
            partners: [
              {
                partner_name: row?.Partner || "",
                partner_docname: row?.partnerDoc || "",
              },
            ],
          }));

          navigate(
            location.state?.requestId
              ? `/create-request/${location.state.requestId}/report`
              : `/create-request/report`,
            {
              state: {
                settingsData: location.state.settingsData,
                company: convertedCompanies,
                requestId: location.state?.requestId || null,
                isEditMode: isEditMode,
                reportData: location.state?.reportData || null,  // ADD THIS
              },
            }
          );

          console.log("convertedCompanies: ", convertedCompanies);
        }}
        onPreview={() => console.log("Preview clicked")}
        onSave={async () => {
          await onSubmit();
        }}
        isValid={selectedCompanies.length > 0}
        showPreview={false}
        onBack={() => navigate(
          location.state?.requestId
            ? `/create-request/${location.state.requestId}/settings`
            : `/create-request/settings`,
          {
            state: {
              settingsData: location.state?.settingsData,
              companiesData: location.state?.companiesData || [],
              reportData: location.state?.reportData || [],
              requestId: location.state?.requestId || null,
              isEditMode: isEditMode,
            },
          }
        )}
        leftOffset={240}   // ← pass sidebar width as prop
      />


      {/* Add Companies Modal */}

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={modalStyles}>
          <Box
            sx={{
              display: screen === 1 ? 'flex' : 'none',
              flexDirection: 'column',
              flex: 1,
              minHeight: 0,
              overflow: 'hidden'
            }}
          >

            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              mb={2}
            >
              <Typography id="modal-modal-title" variant="h6" component="h2">
                Add Companies
              </Typography>

              <CommonButton
                variant="contained"
                size="medium"
                color="secondary"
                sx={arrowButtonStyles}
                onClick={handleClose}
              >
                <ListItemIcon>
                  <CloseIcon sx={{ width: "30px" }} />
                </ListItemIcon>
              </CommonButton>
            </Box>

            <GradeReportsHeaderActions
              searchText={searchText}
              onSearchChange={setSearchText}
              onOpenColumns={handleOpenColumns}
              onOpenFilters={handleOpenFilters}
              isStatusFilterActive={false}
            />

            <GradeReportsGrid
              key={`grade-reports-${modalKey}`}
              tableRef={tableRef}
              apiRef={gridApiRef}
              searchText={searchText}
              isCheckboxColumn={true}
              isLocationColumn={true}
              isStatusColumn={false}
              isLastActivityColumn={false}
              isGradeColumn={true}
              isInvestmentCapitalColumn={true}
              isCashOutDateColumn={true}
              isActionColumn={false}
              onCompaniesChange={handleCompaniesFromChild}
              hideFooterSelectedRowCount={true}
              hideFooter={true}
              selectedCompanies={selectedCompanies}
            />

          </Box>

          {/* Screen 2 */}
          <Box
            sx={{
              display: screen === 2 ? 'flex' : 'none',  // ← was 'block'
              flexDirection: 'column',
              flex: 1,
              minHeight: 0,
              overflow: 'hidden'
            }}
          >

            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              mb={2}
              sx={{ flexShrink: 0 }}   // ADD
            >
              <div>
                <div>
                  <Typography
                    id="modal-modal-title"
                    variant="h6"
                    component="h2"
                  >
                    Send to
                  </Typography>
                </div>
                <div>
                  <Typography>
                    You have selected companies with multiple partners; please
                    choose to whom the request will be directed.
                  </Typography>
                </div>
              </div>

              <CommonButton
                variant="contained"
                size="medium"
                color="secondary"
                sx={arrowButtonStyles}
                onClick={handleClose}
              >
                <ListItemIcon>
                  <CloseIcon sx={{ width: "30px" }} />
                </ListItemIcon>
              </CommonButton>
            </Box>



            {/* Screen 2 — replace the DataGridPro directly with this: */}
            <Box sx={{ flex: 1, overflow: "hidden", minHeight: 0 }}>
              <DataGridPro
                rows={groupedData}
                columns={groupedColumns}
                sx={{ height: "100%" }}
                hideFooterSelectedRowCount={true}
                hideFooter={true}
              />
            </Box>
          </Box>

          {/* Navigation Button */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mt: 1,
              flexShrink: 0,   // ADD — prevents this row from being squeezed out
              //   pt: 2,
              // borderTop: 1,
              // borderColor: "divider",
            }}
          >
            {/* Back button (only shown on screen 2) */}
            {screen === 2 && (
              <CommonButton
                variant="contained"
                size="medium"
                color="secondary"
                onClick={prevScreen}
              >
                <ListItemIcon>
                  <ArrowBackIcon />
                </ListItemIcon>
                Back
              </CommonButton>
            )}

            {/* Spacer to push next button to right when on screen 1 */}
            {screen === 1 && <Box sx={{ flexGrow: 1 }} />}

            {/* Next/Close button */}
            {screen === 1 ? (
              <Button
                variant="contained"
                onClick={nextScreen}
                endIcon={<ArrowForwardIcon />}
                sx={{ ml: "auto" }}
              >
                Add Companies
              </Button>
            ) : (
              <Button variant="contained" onClick={aggregateRows}>
                Confirm
              </Button>
            )}
          </Box>
        </Box>
      </Modal>
    </Box>
  );
};

export default Step2Companies;
